import { Link } from 'react-router-dom';
import { contact, formatFullAddress } from '@/content/et/contact';
import { site } from '@/content/et/site';
import { formatMailto, formatPhoneHref } from '@/lib/format';
import { useMapsCta } from '@/lib/mapsCta';
import styles from './SiteFooter.module.css';

export function SiteFooter() {
  const year = new Date().getFullYear();
  const mapsCta = useMapsCta();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <p className={styles.meta}>
          {formatFullAddress()}
          <span className={styles.sep}>·</span>
          <a href={formatPhoneHref(contact.phoneE164)}>
            {contact.phoneDisplay}
          </a>
          <span className={styles.sep}>·</span>
          <a href={formatMailto(contact.email, 'Päring autoremont')}>
            {contact.email}
          </a>
        </p>

        <nav className={styles.nav} aria-label="Jalus">
          <a href="/#teenused">{site.nav.services}</a>
          <a href="/?mode=tire#teenused">{site.nav.pricing}</a>
          <a href="/#kontakt">{site.nav.contact}</a>
          <Link to="/privaatsus">{site.nav.privacy}</Link>
          <a
            href={mapsCta.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {mapsCta.isApple ? 'Apple Maps' : 'Maps'}
          </a>
        </nav>
      </div>

      <div className={`container ${styles.bottom}`}>
        <span>
          © {year} {contact.legalName}
        </span>
        <span className={styles.mono}>EE · PÄRNU</span>
      </div>
    </footer>
  );
}
